"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentSection = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
require("@/components/common/text/semantics/heading");
/**
 * <mm-content-section>
 * 제목과 본문을 한 묶음으로 세우는 콘텐츠 섹션입니다.
 * 제목이 그 묶음을 대표하므로 heading은 필수입니다. heading-level(기본 2)은 제목의 단계와 크기를 정하며,
 * 섹션이 문서 구조에서 놓인 자리에 맞춰 지정합니다.
 * action 슬롯은 제목 줄 오른쪽에 놓이며, "모두 보기" 링크처럼 섹션 전체에 걸리는 동작을 받습니다.
 */
let ContentSection = class ContentSection extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.heading = '';
        this.headingLevel = 2;
    }
    render() {
        return (0, lit_1.html) `
      <section>
        <header>
          <mm-heading level=${this.headingLevel}>${this.heading}</mm-heading>
          <slot name="action"></slot>
        </header>
        <slot></slot>
      </section>
    `;
    }
};
ContentSection.styles = (0, lit_1.css) `
    :host {
      display: block;
    }

    section {
      display: flex;
      flex-direction: column;
      gap: var(--space-3);
    }

    header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: var(--space-3);
    }
  `;
__decorate([
    (0, decorators_js_1.property)({ type: String })
], ContentSection.prototype, "heading", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: Number, attribute: 'heading-level' })
], ContentSection.prototype, "headingLevel", void 0);
ContentSection = __decorate([
    (0, decorators_js_1.customElement)('mm-content-section')
], ContentSection);
exports.ContentSection = ContentSection;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29udGVudC1zZWN0aW9uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiY29udGVudC1zZWN0aW9uLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLDZCQUEyQztBQUMzQyxxREFBMkQ7QUFFM0Qsc0RBQW1EO0FBRW5EOzs7Ozs7R0FNRztBQUVJLElBQU0sY0FBYyxHQUFwQixNQUFNLGNBQWUsU0FBUSxnQkFBVTtJQUF2Qzs7UUFtQnVCLFlBQU8sR0FBRyxFQUFFLENBQUE7UUFDZ0IsaUJBQVksR0FBRyxDQUFDLENBQUE7SUFhMUUsQ0FBQztJQVhDLE1BQU07UUFDSixPQUFPLElBQUEsVUFBSSxFQUFBOzs7OEJBR2UsSUFBSSxDQUFDLFlBQVksSUFBSSxJQUFJLENBQUMsT0FBTzs7Ozs7S0FLMUQsQ0FBQTtJQUNILENBQUM7O0FBL0JNLHFCQUFNLEdBQUcsSUFBQSxTQUFHLEVBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7O0dBaUJsQixDQUFBO0FBQzJCO0lBQTNCLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsQ0FBQzsrQ0FBYTtBQUNnQjtJQUF2RCxJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFFLFNBQVMsRUFBRSxlQUFlLEVBQUUsQ0FBQztvREFBaUI7QUFwQjdELGNBQWM7SUFEMUIsSUFBQSw2QkFBYSxFQUFDLG9CQUFvQixDQUFDO0dBQ3ZCLGNBQWMsQ0FpQzFCO0FBakNZLHdDQUFjIn0=